<template>
  <div id="app" class="home page-template page-template-full-width-page page-template-full-width-page-php page page-id-217 custom-background frontend siteorigin-panels siteorigin-panels-before-js siteorigin-panels-home">
    <div id="page" class="hfeed site">
      <a class="skip-link screen-reader-text" href="#content">Skip to content</a>
      <a class="menu-open dashicons dashicons-menu" href="#mobile-navigation"></a>
      <a class="menu-close dashicons dashicons-no" href="#"></a>
      <HeaderDiv :logo="mylogo" :facebookIcon="facebook_icon" :instagramIcon="instagram_icon" :twitterIcon = "twitter_icon">
      </HeaderDiv>
      <router-view :storeName="store_name" :facebookIcon="facebook_icon" :instagramIcon="instagram_icon" :twitterIcon = "twitter_icon"></router-view>
      <FooterDiv :logo="mylogo" :year="copyright_year" :storeName="store_name" ></FooterDiv>
    </div>
  </div>
</template>

<script>
import HeaderDiv from './components/Header'
import FooterDiv from './components/Footer'
import api from './api.js'

export default {
  name: 'App',
  data () {
    return {
      //header logo
      mylogo:"",
      copyright_year:"",
      store_name:"",
      summary:"",
      facebook_icon:"",
      instagram_icon:"",
      twitter_icon:"",
    }
  },
  async mounted() {
    const res = await api.get('/api/indexCommon');
    this.mylogo = this.$consts.serverPath + res.data.message.logo;
    this.copyright_year = res.data.message.copyright_year;
    this.store_name = res.data.message.store_name;
    this.facebook_icon = this.$consts.serverPath + res.data.message.facebook_icon;
    this.instagram_icon = this.$consts.serverPath + res.data.message.instagram_icon;
    this.twitter_icon = this.$consts.serverPath + res.data.message.twitter_icon;
  },
  components:{
    HeaderDiv, FooterDiv
  }
}
</script>

<style>
#app {
background-color: rgb(255,255,255) !important;
/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue